(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import styled from 'styled-components';
var StyledTd = styled('td').withConfig({
  displayName: "Td__StyledTd",
  componentId: "sc-qhbbyj-0"
})(["", " ", ""], function (props) {
  return props.textAlign && "text-align: ".concat(props.textAlign, ";");
}, function (props) {
  return props.onClick || props.role === 'button' ? "\n    transition: background-color 0.1s;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #f6f6f6;\n    } " : '';
});
var _default = StyledTd;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledTd, "StyledTd", "/home/vsts/work/1/s/src/components/tables/Td.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/tables/Td.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();